"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var callout_exports = {};
__export(callout_exports, {
  CalloutNode: () => CalloutNode
});
module.exports = __toCommonJS(callout_exports);
var import_text_core = require("@hcengineering/text-core");
var import_core = require("@tiptap/core");
const CalloutNode = import_core.Node.create({
  name: "callout",
  group: "block",
  content: "block+",
  defining: true,
  addAttributes() {
    return {
      kind: {
        default: "info",
        parseHTML: /* @__PURE__ */ __name((element) => (0, import_text_core.getCalloutKind)(element.getAttribute("data-kind")), "parseHTML"),
        renderHTML: /* @__PURE__ */ __name((attributes) => ({ "data-kind": (0, import_text_core.getCalloutKind)(attributes.kind) }), "renderHTML")
      },
      emoji: {
        default: null,
        parseHTML: /* @__PURE__ */ __name((element) => element.getAttribute("data-emoji"), "parseHTML"),
        renderHTML: /* @__PURE__ */ __name((attributes) => attributes.emoji == null ? {} : { "data-emoji": attributes.emoji }, "renderHTML")
      }
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="callout"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", (0, import_core.mergeAttributes)(HTMLAttributes, { "data-type": "callout" }), 0];
  },
  addCommands() {
    return {
      setCallout: /* @__PURE__ */ __name((attributes = {}) => ({ commands }) => commands.wrapIn(this.name, attributes), "setCallout"),
      unsetCallout: /* @__PURE__ */ __name(() => ({ commands }) => commands.lift(this.name), "unsetCallout")
    };
  },
  addKeyboardShortcuts() {
    const liftEmptyCallout = /* @__PURE__ */ __name(() => {
      const { $from, empty } = this.editor.state.selection;
      return empty && $from.depth > 1 && $from.node(-1).type.name === this.name && this.editor.commands.liftEmptyBlock();
    }, "liftEmptyCallout");
    return {
      Enter: liftEmptyCallout,
      Backspace: liftEmptyCallout
    };
  }
});
//# sourceMappingURL=callout.js.map
